import { render, staticRenderFns } from "./editArticle.vue?vue&type=template&id=2e17912a&scoped=true"
import script from "./editArticle.vue?vue&type=script&lang=js"
export * from "./editArticle.vue?vue&type=script&lang=js"
import style0 from "./editArticle.vue?vue&type=style&index=0&id=2e17912a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e17912a",
  null
  
)

export default component.exports